import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="48" height="48" rx="24" fill="white" />
    <mask id="mask0_24642_5583" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="14" y="14" width="20" height="20">
      <rect x="14" y="14" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_24642_5583)">
      <path d="M25.6667 29.8337V18.167H29V29.8337H25.6667ZM19 29.8337V18.167H22.3333V29.8337H19Z" fill="#333333" />
    </g>
  </svg>
);

export default Icon;
